module.exports = "<header class=\"as-toolbar\"></header>\n"